t = require('views/internal/teacup-with-helpers')('boards_sidebar')

module.exports = t.renderable ->
  t.div '.boards-drawer-header', ->
    t.h3 ->
      t.format 'boards'

  t.div '.board-drawer-content.u-fancy-scrollbar', ->

    t.input '.js-search-boards', { type: 'text', placeholder: t.l('find-boards-by-name-ellipsis') }

    t.div '.js-board-drawer-boards'

    t.div '.js-board-drawer-buttons'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_sidebar.coffee